import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import style from './Protected.module.css'
import ProtectLogoHome from '../Icons/svg/ProtectLogoHome'
import moment from 'moment';
import UserStore from "../../store/user-store";
import {observer} from "mobx-react-lite";
import passEmoji from "../../components/Icons/png/pass_emoji.png"
import {t} from "i18next";

export const Protected = observer(({props, isVpnPage}) => {
        const date = moment(props.plan_end).format('DD.MM.YYYY');

        const lang = UserStore.langCode

        const isPass = props.user_plan === 6 || props.user_plan === 20
        return (
            <div id="banner" className={`${style.card}`}
                 style={isVpnPage ? {flex: "0 0 100%"} : UserStore.userActivePlanData.filter(el => el.user_plan_status).length > 1 ? {flex: "0 0 95%"} : {flex: "0 0 95%"}}>

                {!isPass ? <>
                    <div className={style.card__content}>
                        <div className={style.card__content__text}>
                            <div className={style.protect_status}></div>
                            {lang === "ru" ? <h1>Вы защищены</h1> : <h1>You are protected</h1>}
                        </div>
                        <p>{props.user_plan === 10 ? lang === "ru" ? "Триал истекает: " : "Trial expiring: " : lang === "ru" ? "Подписка истекает: " : "Plan is expiring: "}
                            <span style={{color: "white"}}>{date}</span></p>

                    </div>
                    {!isVpnPage &&
                        <Link className={style.card__btn} to='/vpn'>{lang === "ru" ? "Перейти к VPN" : "Go to VPN"}</Link>}
                    <svg
                        width={81}
                        height={114}
                        viewBox="0 0 81 114"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={style.card__logo}
                    >
                        <g clipPath="url(#clip0_1973_20282)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M31.2135 8.99273C26.0355 11.3228 20.6798 13.2316 15.1983 14.7001L13.3838 15.1614V29.8366C17.1796 28.5149 20.9251 27.0584 24.6125 25.47C32.4581 22.1965 40.0348 18.3537 47.276 13.975C54.5356 18.369 62.1322 22.2238 70.001 25.5062C73.653 27.0722 77.3616 28.5088 81.1193 29.8135V15.1614L79.3051 14.7001C73.8156 13.2405 68.4524 11.3401 63.2658 9.01696C58.1729 6.79855 53.2552 4.19231 48.5581 1.22106L47.2515 0.370972L45.9209 1.1965C41.2237 4.16808 36.3069 6.77432 31.2135 8.99273Z"
                                fill="white"
                            />
                            <path
                                d="M24.6098 25.467C16.6515 28.8954 8.42222 31.7087 0 33.8803V60.2228C0 82.3164 11.544 97.5661 23.4251 107.443C29.3704 112.383 35.3462 115.927 39.8652 118.232C42.1209 119.382 43.9993 120.217 45.3088 120.757C45.9138 121.006 46.3894 121.189 46.7191 121.31H46.7396L47.3175 121.506C48.7156 120.988 59.9935 116.661 71.2052 107.361C83.0924 97.5004 94.6409 82.2946 94.6409 60.2228V33.8812C86.209 31.7224 77.9687 28.9212 69.9983 25.5032C62.1295 22.2209 54.5328 18.366 47.2733 13.972C40.0321 18.3507 32.4554 22.1935 24.6098 25.467Z"
                                fill="#E79C00"
                            />
                        </g>
                        <defs>
                            <linearGradient
                                id="paint0_linear_1973_20282"
                                x1={90.5}
                                y1={185.5}
                                x2={47.3204}
                                y2={13.972}
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop offset={0.0001} stopColor="#ABC653" />
                            </linearGradient>
                            <clipPath id="clip0_1973_20282">
                                <rect width={95} height={122} fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </> : (
                    <>
                        <svg
                            style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -58%)"}}
                            xmlns="http://www.w3.org/2000/svg" width="354" height="119" viewBox="0 0 354 119"
                             fill="none">
                            <g opacity="0.7" filter="url(#filter0_f_4001_13771)">
                                <ellipse cx="177" cy="-4.00391" rx="117" ry="63" fill="#EB6A04"/>
                            </g>
                            <g filter="url(#filter1_f_4001_13771)">
                                <ellipse cx="177" cy="-10.0039" rx="70" ry="30" fill="#FF8F21"/>
                            </g>
                            <defs>
                                <filter id="filter0_f_4001_13771" x="0" y="-127.004" width="354" height="246"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                                    <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_4001_13771"/>
                                </filter>
                                <filter id="filter1_f_4001_13771" x="77" y="-70.0039" width="200" height="120"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                                    <feGaussianBlur stdDeviation="15" result="effect1_foregroundBlur_4001_13771"/>
                                </filter>
                            </defs>
                        </svg>
                        <div className={style.card__content}>
                            <img style={{zIndex: 3, position: "relative"}} src={passEmoji} alt="plan_image" width={30}
                                 height={30}/>
                            <div className={style.card__content__text} style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: "center",
                                position: "relative",
                                zIndex: 10
                            }}>
                                <h1 style={{fontSize: 20}}>{t("banners.pass_plan_banner.h1")}</h1>
                                <p style={{fontSize: 16, maxWidth: 248, textAlignLast: "center", fontWeight: 400}}>
                                    {t("banners.pass_plan_banner.p1")}
                                </p>
                            </div>


                        </div>
                    </>
                )
                }
            </div>
        )
    }
)